import React from "react";
import { X, Eraser } from "lucide-react";

/**
 * CRM-R05 · Chips de filtros activos + contador + "Limpiar todo".
 * Props:
 *   chips: [{ key, label, onClear }]   filtros activos
 *   onClearAll: () => void
 */
export const ActiveFilterChips = ({ chips = [], onClearAll }) => {
  if (!chips.length) return null;
  return (
    <div className="flex items-center flex-wrap gap-1.5 mb-2" data-testid="active-filter-chips">
      <span className="text-[10px] uppercase tracking-wide text-gray-400 font-bold mr-0.5">
        {chips.length} filtro{chips.length === 1 ? "" : "s"}:
      </span>
      {chips.map((c) => (
        <span
          key={c.key}
          className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 inline-flex items-center gap-1"
          data-testid={`filter-chip-${c.key}`}>
          {c.label}
          {c.onClear && (
            <button onClick={c.onClear} className="text-indigo-400 hover:text-rose-600" title="Quitar filtro" data-testid={`filter-chip-clear-${c.key}`}>
              <X size={11} />
            </button>
          )}
        </span>
      ))}
      {onClearAll && (
        <button
          onClick={onClearAll}
          data-testid="filter-chips-clear-all"
          className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-white text-rose-600 border border-rose-200 hover:bg-rose-50 inline-flex items-center gap-1">
          <Eraser size={11} /> Limpiar todo
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
